<template>
  <div class="footer-com">
    <div class="main-container">
      <div class="clearfix">
        <div class="footer-language-toggle">
          <dl class="footer-nav-item">
            <dt>{{ $t('labels.language') }}</dt>
            <dd>
              <LangToggle :outline="true" class="footer-lang-toggle"></LangToggle>
            </dd>
            <dd>
              <div class="community-links" style="float: right">
                <!--<v-popover class="community-links-item" trigger="hover">
                  <a href="javascript:void(0)" title="wechat">
                    <svg id="Layer_1" class="iconfont-symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
                      <path
                        class="cls-1"
                        d="M62.74,46.36a3.06,3.06,0,1,1,3.05-3,3,3,0,0,1-3.05,3m-15.26,0a3.06,3.06,0,1,1,3.05-3,3,3,0,0,1-3.05,3M70.09,63.83C74.92,60.33,78,55.16,78,49.41c0-10.54-10.25-19.08-22.89-19.08S32.22,38.87,32.22,49.41,42.47,68.49,55.11,68.49a27.18,27.18,0,0,0,7.47-1,2.13,2.13,0,0,1,.67-.1,2.4,2.4,0,0,1,1.22.35l5,2.89a.78.78,0,0,0,.44.15.77.77,0,0,0,.76-.77,2.08,2.08,0,0,0-.12-.55c0-.11-.65-2.41-1-3.85a2,2,0,0,1-.08-.49,1.52,1.52,0,0,1,.64-1.24"
                      />
                      <path
                        class="cls-1"
                        d="M38.63,28.5a3.66,3.66,0,1,1,3.66-3.66,3.66,3.66,0,0,1-3.66,3.66m-18.32,0A3.66,3.66,0,1,1,24,24.84a3.66,3.66,0,0,1-3.67,3.66M29.47,9.27C14.3,9.27,2,19.52,2,32.17c0,6.89,3.7,13.1,9.49,17.3A1.81,1.81,0,0,1,12.26,51a1.91,1.91,0,0,1-.1.58C11.7,53.27,11,56,10.93,56.16a2.6,2.6,0,0,0-.15.67.91.91,0,0,0,.91.91,1,1,0,0,0,.53-.17l6-3.47a2.88,2.88,0,0,1,1.46-.42,2.63,2.63,0,0,1,.8.12,32.4,32.4,0,0,0,9,1.26c.51,0,1,0,1.51,0a17.59,17.59,0,0,1-.92-5.61c0-11.53,11.21-20.88,25.05-20.88.5,0,1,0,1.49,0C54.53,17.64,43.17,9.27,29.47,9.27"
                      />
                    </svg>
                  </a>
                  <template slot="popover">
                    <div  style="text-align: center;">
                      <p style="text-align: center;font-size: 12px;margin-bottom: 4px;font-weight: 600;">
                        {{ $t('labels.wechatQrCode') }}
                      </p>
                      <QrCode :text="qrString" />
                    </div>
                  </template>
                </v-popover>-->

                <a
                  href="https://www.facebook.com/GRXTrade-102217968010850/"
                  target="_blank"
                  class="community-links-item"
                  title="facebook"
                >
                  <svg class="iconfont-symbol" aria-hidden="true">
                    <use xlink:href="#icon-facebook"></use>
                  </svg>
                </a>
                <a href="https://twitter.com/TradeGRX" target="_blank" class="community-links-item" title="twitter">
                  <svg class="iconfont-symbol" aria-hidden="true">
                    <use xlink:href="#icon-twitter"></use>
                  </svg>
                </a>
                <a href="https://t.me/grxtrade" target="_blank" class="community-links-item" title="telegram">
                  <svg class="iconfont-symbol" aria-hidden="true">
                    <use xlink:href="#icon-telegram"></use>
                  </svg>
                </a>
              </div>
            </dd>
          </dl>
        </div>
        <nav class="footer-nav">
          <dl class="footer-nav-item">
            <dt>{{ $t('footer.aboutGrx') }}</dt>
            <dd>
              <router-link :to="{ name: 'about' }" class="footer-nav-link">
                {{ $t('footer.aboutGrx.aboutUs') }}
              </router-link>
            </dd>
            <dd>
              <router-link :to="{ name: 'contact-us' }" class="footer-nav-link">
                {{ $t('footer.aboutGrx.contactUs') }}
              </router-link>
            </dd>
            <dd>
              <router-link :to="{ name: 'company-profile' }" class="footer-nav-link">
                {{ $t('footer.aboutGrx.companyProfile') }}
              </router-link>
            </dd>
            <!--<dd>
              <router-link :to="{ name: 'affiliate' }" class="footer-nav-link">
                {{ $t('footer.aboutGrx.affProgram') }}
              </router-link>
            </dd>-->
          </dl>
          <dl class="footer-nav-item">
            <dt>{{ $t('footer.legal') }}</dt>
            <dd>
              <router-link :to="{ name: 'terms-of-use' }" class="footer-nav-link">
                {{ $t('footer.legal.termsOfUse') }}
              </router-link>
            </dd>
            <dd>
              <router-link :to="{ name: 'aml-policy' }" class="footer-nav-link">
                {{ $t('footer.legal.amlPolicy') }}
              </router-link>
            </dd>
            <dd>
              <router-link :to="{ name: 'risk-statement' }" class="footer-nav-link">
                {{ $t('footer.legal.riskStatement') }}
              </router-link>
            </dd>
            <dd>
              <router-link :to="{ name: 'privacy-policy' }" class="footer-nav-link">
                {{ $t('footer.legal.privacyPolicy') }}
              </router-link>
            </dd>
          </dl>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import LangToggle from '../LangToggle/LangToggle';
import { commonApi } from '../../api/commonApi';
import { mapGetters, mapActions } from 'vuex';
import { actionTypes } from '@/store/action-types';
import { getterTypes } from '@/store/getter-types';
import QrCode from '@/components/QrCode/QrCode';

export default {
  name: 'm-footer',
  components: {
    LangToggle,
    QrCode
  },
  data() {
    return {
      footerData: [],
      wechatQrCode: '',
      qrString: 'a'
    };
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Wechat_QRCode_State])
  },
  methods: {
    ...mapActions([actionTypes.GET_WECHAT_QRCODE_ACTION]),
    getFooterData() {
      commonApi.getFooterData().then(res => {
        this.footerData = res.data;
      });
    },
    getWechatQrCode() {
      return commonApi.getWechatQrCode().then(res => {
        let data = res.data;
        this.qrString = data.link;
      });
    }
  },
  mounted() {
    if (this.qrString === 'a') {
      this.getWechatQrCode();
    }
    let timer = setTimeout(() => {
      clearTimeout(timer);
      // this.getFooterData();
    }, 1500);
  }
};
</script>

<style lang="stylus">
@import "footer.styl"
</style>
